import {Brick, registerBrick, Transaction, File as OFile, CloudObject, ErrorFlow} from 'olympe';
import * as XLSX from 'xlsx';
import {ColumnsDataTypeController} from '../../controllers/ColumnsDataTypeController';

export default class ExportAdminTablesToExcelFile extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {[]} tableArray
     * @param {string} excelFileName
     * @param {string} table
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(File)} setFile
     * @param {function(string)} setFileName
     */
    async update($, [tableArray, excelFileName, table], [forwardEvent, setErrorFlow, setFile, setFileName]) {
        if (tableArray.length > 0) {
            const excelFilePath = excelFileName.endsWith('.xlsx') ?
                excelFileName :
                excelFileName + '.xlsx';

            const columns = await ColumnsDataTypeController.getFilteredColumns(table);

            // Ensure "idx" column is always first
            const idxColumnIndex = columns.findIndex((col) => col.column === 'idx');
            if (idxColumnIndex > 0) {
                const idxColumn = columns[idxColumnIndex];
                columns.splice(idxColumnIndex, 1);
                columns.splice(0, 0, idxColumn);
            }

            // Create the header row with column display names
            const headerRow = columns.map((col) => col.column);

            // Create the data rows by extracting values in the correct column order
            const dataRows = tableArray.map((rowData) => {
                return columns.map((col) => {
                    const value = rowData[col.column];
                    // Return the value, or empty string if undefined/null
                    return value !== undefined && value !== null ? value : '';
                });
            });

            // Combine header and data rows
            const excelData = [headerRow, ...dataRows];

            const wb = XLSX.utils.book_new();
            const wsNew = XLSX.utils.aoa_to_sheet(excelData);

            XLSX.utils.book_append_sheet(wb, wsNew, 'Sheet1');
            // Assign modified headers to worksheet
            const binary = XLSX.writeXLSX(wb, {
                bookType: 'xlsx',
                type: 'array',
                compresion: true,
            });
            const transaction = new Transaction(false);
            const fileTag = transaction.create(OFile);
            transaction.persist(fileTag, false);
            const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            OFile.setContent(transaction, fileTag, excelFilePath, binary, mimeType);
            transaction
                .execute()
                .then(() => {
                    CloudObject.get(fileTag).saveAs(excelFilePath);
                    forwardEvent();
                })
                .catch((message) => console.error(message));
        } else {
            setErrorFlow(ErrorFlow.create('Something went wrong with the generation of Excel.', 1));
        }
    }
}

registerBrick('01902f5f54546cb0771e', ExportAdminTablesToExcelFile);

